import React from 'react'
import { Flex } from 'antd'
import DataSetupItem from './DataSetupItem'
interface Props {
  fileData?: any
  columns?: any
  source?: any
  colChange?: (data: any) => void
  setShowParamModal?: (data: any) => void
}
const ImportDataStep3:React.FC<Props> = (props) => {
  const { fileData, columns, colChange, source, setShowParamModal } = props
  return (
    <div className="import-data-step-3">
      <Flex vertical className='gap-24px'>
        {Object.keys(fileData).map((iskey: any) => (
          <DataSetupItem colChange={(data: any) => {
            if (colChange) {
              colChange(data)
            }
          }} setShowParamModal={(data: any) => {
            if (setShowParamModal) {
              setShowParamModal(data)
            }
          }} key={iskey} source={source} itemFile={fileData[iskey]} fileName={iskey} columns={columns} />
        ))}
      </Flex>
    </div>
  )
}

export default ImportDataStep3
